/**
 * cityArrivals — a link can put a visitor at a PLACE in the city.
 *
 * Khari, 2026-10-27, arriving at the plaza after Avva Digital's set had been
 * called: *"a spawn point at locations is a good idea. please add one for the
 * plaza"*. `world.hypetunes.com/?at=plaza` lands in front of the stage instead
 * of at the welcome sign. First used by the stage notice an artist's owner gets
 * when their set is called (API services/city/CityLifeService.notifyStageOwner).
 *
 * A place is `{ pos: [x, z], look: [x, y, z] }` in world units (a person is
 * ~0.75 tall here). The camera height is the street eye, supplied by the reader
 * (PlanetScene's EYE, which ?eye= tunes), so an arrival stands exactly as tall as
 * walking does. Walking takes over from the arrival pose with no jump.
 * Add a place by adding a line.
 */
export const ARRIVALS = {
  // In front of the plaza stage (components/city/CityPlaces: STAGE at
  // [96, -35.2], facing +z, on the plaza's back edge), centred, in the front
  // row: the whole stage, its screen and the speakers in view. Not further
  // back: the first arc of benches crosses the middle at z -28.2, and standing
  // just behind it put a bench across the bottom of the view.
  plaza: { pos: [96, -29.6], look: [96, 1.0, -35.2] },
};

/** The arrival this page's `?at=` names, at eye height `eye`, or null. */
export function arrivalFromUrl(eye) {
  if (typeof window === 'undefined') return null;
  const at = String(new URLSearchParams(window.location.search).get('at') || '').trim().toLowerCase();
  const place = ARRIVALS[at];
  if (!place) return null;
  return { pos: [place.pos[0], eye, place.pos[1]], look: place.look.slice() };
}
